"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_dom_1 = require("react-router-dom");

var semantic_ui_react_1 = require("semantic-ui-react");

var data_1 = require("../data");

var VisualizationsPage =
/** @class */
function (_super) {
  __extends(VisualizationsPage, _super);

  function VisualizationsPage(props) {
    return _super.call(this, props) || this;
  }

  VisualizationsPage.prototype.render = function () {
    return React.createElement(semantic_ui_react_1.List, {
      divided: true
    }, React.createElement(semantic_ui_react_1.List.Item, null, this.renderVisualizationItem(data_1.VizData.spring)), React.createElement(semantic_ui_react_1.List.Item, null, this.renderVisualizationItem(data_1.VizData.tfjsTsne)), React.createElement(semantic_ui_react_1.List.Item, null, this.renderVisualizationItem(data_1.VizData.anatomogram)));
  };

  VisualizationsPage.prototype.renderVisualizationItem = function (viz) {
    return React.createElement(semantic_ui_react_1.Grid, {
      centered: true,
      columns: 3,
      padded: true,
      relaxed: true
    }, React.createElement(semantic_ui_react_1.Grid.Column, null, React.createElement("img", {
      src: "assets/icons/" + viz.name.toLocaleLowerCase() + "-thumbnail.png",
      alt: "icon for " + viz.name,
      style: {
        height: '100px'
      }
    })), React.createElement(semantic_ui_react_1.Grid.Column, {
      textAlign: 'left'
    }, React.createElement(semantic_ui_react_1.Header, {
      as: 'h2'
    }, viz.name), React.createElement(semantic_ui_react_1.List, null, React.createElement(semantic_ui_react_1.List.Item, null, "" + (viz.listAsOriginal ? 'original: ' : '') + viz.authors.join(', ')), React.createElement(semantic_ui_react_1.List.Item, null, viz.summary), React.createElement(semantic_ui_react_1.List.Item, null, "relevant data: " + viz.relevantData))), React.createElement(semantic_ui_react_1.Grid.Column, {
      stretched: true
    }, React.createElement(semantic_ui_react_1.Grid.Row, null, React.createElement(semantic_ui_react_1.Button, {
      basic: true
    }, React.createElement(react_router_dom_1.Link, {
      to: {
        pathname: '/visualizations/',
        search: "?name=" + viz.name.toLocaleLowerCase()
      }
    }, "details"))), React.createElement(semantic_ui_react_1.Grid.Row, null, React.createElement(semantic_ui_react_1.Button, {
      basic: true
    }, React.createElement(react_router_dom_1.Link, {
      to: {
        pathname: '/dataset',
        search: "?viz=" + viz.name.toLocaleLowerCase()
      }
    }, "launch")))));
  };

  return VisualizationsPage;
}(React.Component);

exports.VisualizationsPage = VisualizationsPage;